import { useEffect, useMemo, useState } from 'react';

import 'app/pages/hosted-checkout/hosted-checkout.scss';
import 'app/pages/hosted-checkout/views/Checkout/styles.scss';
import { useTheme } from './useTheme';
import useIframe from '../../helpers/useIframe';
import { ViewState } from '../../interface';

import { useScript } from 'app/pages/frames/hooks/useScript';
import { initMixpanel, trackEvent } from 'app/util/tagging/mixpanelConfig';

function useCheckout(state: ViewState) {
  const theme = useMemo(() => useTheme(), []);
  const { entity, checkoutRequest } = state;
  const { initIframe, contentLoaded } = useIframe(state);
  const [showIntro, setShowIntro] = useState(true);
  const isDesktop = state?.device?.isDesktop;
  const isSelfHosted = checkoutRequest.type === 'PaymentLink';
  const { status, loadScript } = useScript({
    removeOnUnmount: false,
  });

  useEffect(() => {
    if (typeof window.DigitalFemsaCheckoutComponents !== 'undefined') {
      initIframe();
      initMixpanel();

      const handleMessage = (event: MessageEvent) => {
        if (typeof event.data !== 'object' || !event.data?.eventName) return;

        const { eventName, params } = event.data;

        trackEvent(eventName, params);
      };

      window.addEventListener('message', handleMessage);
      return () => window.removeEventListener('message', handleMessage); 
    }
  }, [status]);

  useEffect(() => {
    loadScript(process.env.COMPONENT_URL!);
  }, []);

  return {
    theme,
    entity,
    checkoutRequest,
    contentLoaded,
    showIntro,
    setShowIntro,
    isDesktop,
    isSelfHosted,
  };
}

export default useCheckout;
